<ng-container *ngIf="personas$ | async as personas">
  <ng-container *ngIf="personaId$ | async as personaId">
    <ng-container *ngIf="personas.length > 1">
      <div *ngFor="let persona of personas" (click)="selectPersona(persona)" [class.selected]="persona.id == personaId">{{signature(persona)}}</div>
    </ng-container>
  </ng-container>
</ng-container>
